module.exports = __webpack_public_path__ + "static/media/AB_K16_6.3cac62c2.jpg";